import React from 'react';

import Page from '../../components/Page';
import Footer from '../../components/Footer';
import { flexContainer, title, keyVisual } from './LastPageStyle';
import imgKey from '../../assets/media/keystatements.webp';
import IndustryArea from '../../components/IndustryArea';

const ComplexityLastPage = () => {
    return (
        <Page fixedPageHeight>
            <div className={flexContainer}>
                <div className={title}>Mit ZMC Geschäftskomplexität bewältigen</div>
                <h2>Wir unterstützen Sie bei der Reduktion der Geschäftskomplexität</h2>
                <p>
                    Zellweger Management Consultants (ZMC) bietet umfassende Beratungs-, Umsetzungs- &amp; Trainings-
                    sowie Durchführungsleistungen im Kompetenzfeld Geschäftskomplexität.
                </p>
                <img className={keyVisual} src={imgKey} alt="Schlüssel" />
                <h2>Namhafte Kunden vertrauen uns</h2>
                <p>Internationale Unternehmen wählen uns als Partner, um Geschäftskomplexität zu meistern.</p>

                <IndustryArea />

                <h2>Nachhaltige Resultate und ein attraktiver Payback</h2>
                <p>
                    Sie setzen auf ein erfahrenes Team. Unser Expertise im Bereich Geschäftskomplexität und unsere
                    ausgewiesene Umsetzungsstärke garantieren Ihnen nachhaltige Resultate und eine rasche Amortisation
                    der Projektkosten.
                </p>
                <div style={{ flex: 1 }} />
                <Footer />
            </div>
        </Page>
    );
};

export default ComplexityLastPage;
